import DictionaryLinks from 'components/DictionaryLinks/DictionaryLinks'

export default DictionaryLinks
